define.alias("ember-composable-helpers/helpers/queue", "settings/helpers/queue");